import { Card, CardBody, Col } from "reactstrap";
import { Sizes } from "../../../constants";
import { AvatarSizeData, SizesSubTitle } from "../../../data/uiKits/Avatars";
import { dynamicImage } from "../../../utils";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

const AvatarSizes = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={Sizes} span={SizesSubTitle} />
        <CardBody className="avatar-showcase">
          <div className="avatars">
            {AvatarSizeData &&
              AvatarSizeData.map((item, index) => (
                <div key={index} className="avatar">
                  <Image className={`img-${item.class} rounded-circle`} src={dynamicImage(`avtar/${item.image}`)} alt="user profile" />
                </div>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AvatarSizes;
